import React, {Component} from 'react';
import ReactPlayer from 'react-player';
import {toast} from 'react-toastify';

import ErrorMsg from "../common/ErrorMsg";
import {getUser, setUser} from "../../utils/TokenManager";
import {STAFF_FIRST_TIME_VIDEO} from "./Constants";


class DashboardVideo extends Component {

    state = {
        isVideoCompleted: false,
        video: {...STAFF_FIRST_TIME_VIDEO},
        playedAgain: false
    }

    componentDidMount = () => {
        this.getFirstTimeVideo();
    }

    getFirstTimeVideo = async () => {
        try {
            const result = await this.props.getFirstTimeVideo();
            if (result) {
               this.setState({video: result});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        return false;
    }

    handleVideoEnd = async () => {
        try {
            const result = await this.props.updateDashboardVideoStatus();
            if (result) {
                const user = getUser();
                const modifiedUserDet = {...user, seen_dashboard_video: true};
                setUser(modifiedUserDet);
               this.setState({isVideoCompleted: true});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        return false;
    }

    logout = () => {
        this.props.logOut();
    };
    
    render = () => {
        const {isVideoCompleted, video, playedAgain} = this.state;

        return (
            <section className="h-100 d-flex flex-column align-items-center justify-content-center">
                {/* <p style={{width: "70%", textAlign: "center"}}>
                    This Video provides the overview of dashboard. 
                </p> */}
                <div className="border staff-dashboard-video-div">
                    <div className="staff-dashboard-video-header position-relative">
                        {(!isVideoCompleted || playedAgain) &&  video.title}
                        {isVideoCompleted && playedAgain &&
                            <i className="font-18 fa fa-times-circle close" 
                                onClick={this.props.updateStatusInStore}
                            ></i>
                        }
                    </div>
                    <div className="player-wrapper-full">
                        {isVideoCompleted ?
                            playedAgain ?
                                <ReactPlayer url={video.link} 
                                    playing controls width='100%' height='100%'
                                    onEnded={() => this.setState({playedAgain: false})}
                                />
                                :
                                <div className="d-flex flex-column justify-content-center 
                                    align-items-center h-100"
                                >
                                    <button className="btn btn-success mb-3"
                                        onClick={this.props.updateStatusInStore}
                                        title="On click, The page will be redirected to dashboard"
                                    >
                                        Go to Dashboard
                                    </button>
                                    <button className="btn btn-info my-3"
                                        onClick={() => this.setState({playedAgain: true})}
                                    >
                                        <i className="fa fa-repeat pr-2"></i>
                                        Play The Video Again
                                    </button>
                                    <a className="user-link" 
                                        style={{textDecoration: "underline"}}
                                        onClick={this.logout}
                                    >
                                        Back to Login
                                    </a>
                                </div>
                            :
                            <ReactPlayer url={video.link} 
                                playing controls width='100%' height='100%'
                                onEnded={this.handleVideoEnd} 
                            />
                        }
                    </div>
                    <div className="staff-dashboard-video-footer">
                        {(!isVideoCompleted || playedAgain) &&  
                            <a className="user-link" style={{textDecoration: "underline"}}
                                onClick={this.logout}
                            >
                                Back to Login
                            </a>
                        }
                        {isVideoCompleted && playedAgain &&
                            <a className="user-link" style={{textDecoration: "underline"}}
                                onClick={this.props.updateStatusInStore}
                            >
                                Go to Dashboard
                            </a>
                        }
                    </div>
                </div>
            </section>
        );
    }
}

export default DashboardVideo;



// WEBPACK FOOTER //
// ./src/components/staffDashboard/DashboardVideo.js